function OnConfig($stateProvider, $locationProvider, $urlRouterProvider, $compileProvider, $translateProvider, toastrConfig) {
  'ngInject';

  if (process.env.NODE_ENV === 'production') {
    $compileProvider.debugInfoEnabled(false);
  }

  $locationProvider.html5Mode({
    enabled: false,
    requireBase: false
  });

  $stateProvider
    // 공통 - 인트로
    .state('Intro', {
      url: '/intro',
      controller: 'IntroCtrl as intro',
      templateUrl: 'intro.html',
      title: '인트로',
      resolve: {
        preload: function($state, $q, toastr, AuthService, UserService) {
          var vm = {};
          
          if (location.protocol === 'file:') {
            vm.isMobileApp = true;
          }

          vm.loginData = {
            login_id: null,
            passwd: null,
          };

          vm.submit = function () {

            UserService.login(vm.loginData).then(function (res) {
              var data = res.data;
              if (data.result === 'NOT') {
                toastr.error('없는 사용자 아이디입니다.');
              } else if (data.result === 'NO_MATCH') {
                toastr.error('비밀번호가 맞지 않습니다.');
              } else if (data.result === 'NOT_YET') {
                toastr.error('팀 승인이 필요한 아이디입니다.');
              } else {
                if (vm.autoLogin == '1') {
                  window.localStorage.setItem('login_id', vm.loginData.login_id);
                  window.localStorage.setItem('passwd', vm.loginData.passwd);
                } else {
                  window.localStorage.removeItem('login_id');
                  window.localStorage.removeItem('passwd');
                }

                AuthService.setUser(data);
                var d = $q.defer();
                var dataInfo = {
                  "user_id": data.user_id,
                  "uuid": data.uuid
                }
                d.resolve(dataInfo);
                return d.promise;
              }
            })
              .then(function (dataInfo) {

                UserService.info(dataInfo).then(function (res) {
                  AuthService.setInfo(res.data);

                  // 팀 설정이 되어 있지 않은 경우 - sa21c 관리자 제외 : SA21C parent_id(18), 본사관리자(22), 최고관리자(23), 후원팬(17), 일반팬(28) 제외
                  if (res.data.team_id === '0' && res.data.user_type_id != '17' && res.data.user_type_id != '18' && res.data.user_type_id != '22' && res.data.user_type_id != '23' && res.data.user_type_id != '28') {
                    toastr.error('팀을 선택하지 않으셨습니다. 수정을 클릭하시고 팀을 선택해주세요');
                    $state.go('Service.member', { 'target': 'MyInfo', 'team_id': 0 });
                  } else {
                    // 후원팬, 일반팬
                    if (res.data.user_type_id == '17' || res.data.user_type_id == '28') {
                      $state.go('Service.member', { 'target': 'MyInfo', 'team_id': 0 });
                    } else {
                      if (vm.loginData.login_id === 'ceo@sa21c.com') {
                        $state.go('Service.admin', { type_code:'team', 'v': 'sa21c' });
                      } else {
                        $state.go('Service.planner', { type_code:'team', team_id:res.data.team_id });
                      }
                    }
                  }
                });

              })
          };

          // 모바일앱에서 localStorage 에 login_id 와 passwd 가 있는 경우 자동 로그인
          if (vm.isMobileApp) {
            vm.loginData.login_id = window.localStorage.getItem('login_id');
            vm.loginData.passwd = window.localStorage.getItem('passwd');

            if (vm.loginData.login_id && vm.loginData.passwd) {
              vm.autoLogin = '1';
              vm.submit();
            }
          }
        }
      }
    })
    // 공통 - 회원가입, 로그인
    .state('Accounts', {
      abstract: true,
      url: '/accounts?lang',
      template: '<div ui-view></div>',
      resolve: {
        translateReady: ['$translate', function($translate) {
          return $translate.onReady();
        }]
      }
    })
    .state('Accounts.join', {
      url: '/join',
      controller: 'AccountsJoinCtrl as vm',
      templateUrl: 'accounts/join.html',
      title: '회원가입'
    })
    .state('Accounts.login', {
      url: '/login',
      controller: 'AccountsLoginCtrl as accountsLogin',
      templateUrl: 'accounts/login.html',
      title: '로그인'
    })
    .state('Accounts.findId', {
      url: '/find_id',
      controller: 'AccountsFindIdCtrl as accountsFindId',
      templateUrl: 'accounts/find-id.html',
      title: '아이디 찾기'
    })
    .state('Accounts.resetPass', {
      url: '/reset_pass',
      controller: 'AccountsResetPassCtrl as accountsResetPass',
      templateUrl: 'accounts/reset-pass.html',
      title: '비밀번호 찾기'
    })
    .state('Accounts.payment', {
      url: '/payment',
      controller: 'AccountsPaymentCtrl as accountsPayment',
      templateUrl: 'accounts/payment.html',
      title: '결제'
    })
    .state('Accounts.privacy', {
      url: '/privacy',
      controller: 'AccountsPrivacyCtrl as vm',
      templateUrl: 'accounts/privacy.html',
      title: '개인정보 취급방침'
    })
    // 이미지 업로드를 위해서 필요
    .state('Result', {
      url: '/result',
      controller: 'ResultCtrl as result',
      templateUrl: 'result.html',
      title: 'Result'
    })

    .state('Service', {
      abstract: true,
      url: '/service?v&isPaid&team_id&manager_admin_team_id&owner_login_id&owner_uuid&fan_team_id&fan_user_id&fan_user_team_id&fan_login_id&fan_user_name&coach_player_team_id&continent_id&country_id&team1_id&team2_id&team3_id&team4_id&lang',
      controller: 'BaseCtrl as vm',
      templateUrl: 'service/base.html',
      resolve: {
        players: function ($stateParams, AuthService, PlayerService) {
          var user = AuthService.getUser();

          if (user) {

            // console.log('user.....', user)

            var loginInfo = {
              login_id: user.login_id,
              uuid: user.uuid,
              all: 'Y'
            };

            // 전체관리자가 선택한 team_id
            if ($stateParams.manager_admin_team_id) {
              loginInfo.team_id = $stateParams.manager_admin_team_id;
            }
            // 팬이 선택한 team_id
            else if ($stateParams.fan_team_id) {
              loginInfo.team_id = $stateParams.fan_team_id;
            }
            // 감독-선수 소속팀 관련 수정
            // 감독-선수가 선택한 team_id
            else if ($stateParams.coach_player_team_id) {
              loginInfo.team_id = $stateParams.coach_player_team_id;
            }

            return PlayerService.getPlayers(loginInfo);

          } else {
            return null;
          }
        },
        // 접속가능한 메뉴 조회
        menus: function($q, AuthService, AdminService) {
          var user = AuthService.getUser(),
            d = $q.defer();

          if (user) {
            AdminService.menus({
              login_id: user.login_id,
              uuid: user.uuid,
            }).then(function (res) {
              d.resolve(res.data.menus);
            }).catch(function(err) {
              d.reject();
              console.log(err);
            });
            return d.promise;
          } else {
            return null;
          }
        },
        translateReady: ['$translate', function($translate) {
          return $translate.onReady();
        }]
      }
    })

    .state('Service.main', {
      url: '/main',
      controller: 'MainCtrl as vm',
      templateUrl: 'service/main.html',
      title: '메인'
    })

    .state('Service.dashboard', {
      url: '/dashboard?debug',
      controller: 'DashboardCtrl as vm',
      templateUrl: 'service/dashboard.html',
      title: '대시보드'
    })

    .state('Service.health', {
      url: '/health/:tab',
      title: '건강관리',
      views: {
        '': {
          controller: 'HealthCtrl as vm',
          templateUrl: 'service/health.html',
        }
      }
    })
    .state('Service.healthDetail', {
      url: '/health/:user_id/:tab',
      title: '건강관리 상세',
      views: {
        '': {
          controller: 'HealthDetailCtrl as vm',
          templateUrl: 'service/health-detail.html',
        }
      }

    })
    .state('Service.injury', {
      url: '/injury',
      // controller: 'InjuryCtrl as vm',
      // templateUrl: 'service/injury.html',
      title: '부상관리',
      views: {
        '': {
          controller: 'InjuryCtrl as vm',
          templateUrl: 'service/injury.html',
        }
      }
    })
    .state('Service.injuryDetail', {
      url: '/injury/:user_id',
      // controller: 'InjuryDetailCtrl as injuryDetail',
      // templateUrl: 'service/injury-detail.html',
      title: '부상관리 상세',
      views: {
        '': {
          controller: 'InjuryDetailCtrl as vm',
          templateUrl: 'service/injury-detail.html',
        }
      }

    })

    .state('Service.entrySelect', {
      url: '/entry_select/:id?mode&type_code&type_name&team_code&country_name&team_name&team_id&year&month',
      controller: 'EntrySelectCtrl as vm',
      templateUrl: 'service/entry-select.html',
      title: '엔트리 선택'
    })


    .state('Service.event', {
      url: '/event?type_code&type_name&year&month',
      controller: 'EventCtrl as vm',
      templateUrl: 'service/event.html',
      title: '경기 및 훈련 목록'
    })

    .state('Service.eventDetail', {
      url: '/event/:id?type_code&type_name&year&month',
      title: '경기 및 훈련설정',
      views: {
        '': {
          templateUrl: 'service/event-detail.html',
          controller: 'EventDetailCtrl as vm',
        },
        'my_team@Service.eventDetail': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'my_team',
                team_name: '우리팀',
              };
            }
          },
        },
        'oppo_team@Service.eventDetail': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'oppo_team',
                team_name: '상대팀',
              };
            }
          },
        }

      }
    })

    .state('Service.eventRecord', {
      url: '/event_record/:id?type_code&type_name&year&month',
      title: '기록',
      views: {
        '': {
          templateUrl: 'service/event-record.html',
          controller: 'EventRecordCtrl as vm',
        },
        'my_team@Service.eventRecord': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'my_team',
                team_name: '우리팀',
              };
            }
          },
        },
        'oppo_team@Service.eventRecord': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'oppo_team',
                team_name: '상대팀',
              };
            }
          },
        }
      }
    })

    .state('Service.eventAnalysis', {
      url: '/event_analysis/:id?type_code&type_name&year&month',
      title: '분석',
      views: {
        '': {
          templateUrl: 'service/event-analysis.html',
          controller: 'EventAnalysisCtrl as vm',
        },
        'my_team@Service.eventAnalysis': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'my_team',
                team_name: '우리팀',
              };
            }
          },
        },
        'oppo_team@Service.eventAnalysis': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'oppo_team',
                team_name: '상대팀',
              };
            }
          },
        }
      }
    })


    .state('Service.eventContent', {
      url: '/event_content/:id?type_code&type_name&year&month',
      title: '분석',
      views: {
        '': {
          templateUrl: 'service/event-content.html',
          controller: 'EventContentCtrl as vm',
        },
        'my_team@Service.eventContent': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'my_team',
                team_name: '우리팀',
              };
            }
          },
        },
        'oppo_team@Service.eventContent': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'oppo_team',
                team_name: '상대팀',
              };
            }
          },
        }
      }
    })


    .state('Service.eventPlayer', {
      url: '/event_player/:id?type_code&type_name&year&month',
      title: '분석',
      views: {
        '': {
          // templateUrl: 'service/player.html',
          // controller: 'PlayerCtrl as vm',
          templateUrl: 'service/event-player.html',
            controller: 'EventPlayerCtrl as vm',

        },
        'my_team@Service.eventPlayer': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                multi_select: true,
                team_code: 'my_team',
                team_name: '우리팀',
              };
            }
          },
        },
        'oppo_team@Service.eventPlayer': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                multi_select: true,
                team_code: 'oppo_team',
                team_name: '상대팀',
              };
            }
          },
        }
      }
    })


    // .state('Service.player', {
    //   url: '/player?type_code&user_id',
    //   title: '선수관리',
    //   views: {
    //     '': {
    //       templateUrl: 'service/player.html',
    //       controller: 'PlayerCtrl as vm',
    //     },
    //     'my_team@Service.player': {
    //       templateUrl: 'service/entry-list.html',
    //       controller: 'EntryListCtrl as vm',
    //       resolve: {
    //         data: function () {
    //           return {
    //             multi_select: true,
    //             team_code: 'my_team',
    //             team_name: '우리팀',
    //             type_code: 'game',
    //             type_name: '경기'
    //           };
    //         }
    //       },
    //     },

    //     // 'oppo_team@Service.player': {
    //     //   templateUrl: 'service/entry-list.html',
    //     //   controller: 'EntryListCtrl as vm',
    //     //   resolve: {
    //     //     data: function () {
    //     //       return {
    //     //         team_code: 'oppo_team',
    //     //         team_name: '상대팀',
    //     //         type_code: 'game',
    //     //         type_name: '경기'
    //     //       };
    //     //     }
    //     //   },
    //     // },


    //     'tab_menu@Service.player': {
    //       templateUrl: 'service/player-tab-menu.html',
    //     },
    //     'ground@Service.player': {
    //       templateUrl: 'service/player-ground.html',
    //     }
    //     // ,
    //     // 'detail@Service.player': {
    //     //   templateUrl: 'service/player-detail.html',
    //     //   controller: 'PlayerDetailCtrl as vm',
    //     //   // resolve: {
    //     //   //   data: function () {
    //     //   //     return {
    //     //   //       multi_select: true,
    //     //   //       team_code: 'my_team',
    //     //   //       team_name: '우리팀',
    //     //   //       type_code: 'game',
    //     //   //       type_name: '경기'
    //     //   //     };
    //     //   //   }
    //     //   // },
    //     // },


    //   }
    // })


    // .state('Service.player', {
    //   url: '/player',
    //   template: '<h1>player</h1>'
    // })

    // .state('Service.playerDetail', {
    //   url: '/player/:id',
    //   template: '<h1>player detail</h1>'
    // })


    .state('Service.player', {
//      url: '/event_player/:id?type_code&type_name&year&month',
      // url: '/player?type_code',
      url: '/player/:id?type_code&type_name',

      title: '선수관리',
      views: {
        '': {
          templateUrl: 'service/player.html',
          controller: 'PlayerCtrl as vm',
        },
        'my_team@Service.player': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                multi_select: true,
                team_code: 'my_team',
                team_name: '우리팀',
                type_code: 'game',
                type_name: '경기'
              };
            }
          },
        },

        'ground@Service.player': {
          templateUrl: 'service/player-ground.html',
        },

        'oppo_team@Service.player': {

          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                multi_select: true,
                team_code: 'oppo_team',
                team_name: '상대팀',
              };
            }
          },
        }



      }
    })


    .state('Service.playerDetail', {
      url: '/player_detail/:id?type_code&type_name&user_id&from',

      title: '선수관리',
      views: {
        '': {
          templateUrl: 'service/player-detail.html',
          controller: 'PlayerDetailCtrl as vm',
        },
        'my_team@Service.playerDetail': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                multi_select: true,
                team_code: 'my_team',
                team_name: '우리팀',
                type_code: 'game',
                type_name: '경기'
              };
            }
          },
        },

        'ground@Service.playerDetail': {
          templateUrl: 'service/player-ground.html',
        }


      }
    })












    .state('Service.planner', {
      url: '/planner?type_code&year&month',
      title: '스마트 플래너',
      views: {
        '': {
          templateUrl: 'service/planner.html',
          controller: 'PlannerCtrl as vm',
        },
        'my_team@Service.planner': {
          templateUrl: 'service/entry-list.html',
          controller: 'EntryListCtrl as vm',
          resolve: {
            data: function () {
              return {
                team_code: 'my_team',
                team_name: '우리팀',
              };
            }
          },
        }
      }
    })

    .state('Service.member', {
      url: '/member?target&payed&popup',
      controller: 'MemberCtrl as vm',
      // reloadOnSearch : false,
      params: {
        obj: null
      },
      templateUrl: 'service/member.html',
      title: '사용자 관리'
    })

    .state('Service.managerAdmin', {
      url: '/manager_admin',
      controller: 'ManagerAdminCtrl as vm',
      params: {
        obj: null
      },
      templateUrl: 'service/manager-admin.html',
      title: '전체 관리자'
    })

    .state('Service.system', {
      url: '/system',
      controller: 'SystemCtrl as system',
      params: {
        obj: null
      },
      templateUrl: 'service/system.html',
      title: 'SGS 관리'
    })
    .state('Service.admin', {
      url: '/admin?admin_menu',
      controller: 'AdminCtrl as vm',
      params: {
        obj: null
      },
      templateUrl: 'service/admin.html',
      title: '시스템 관리'
    })
    .state('Service.device', {
      url: '/device',
      controller: 'DeviceCtrl as device',
      templateUrl: 'service/device.html',
      title: '디바이스 관리'
    });

  $urlRouterProvider.otherwise('/intro');

  // toastr 전역 설정
  angular.extend(toastrConfig, {
    closeButton: true // 닫기 버튼
  });

  // 다국어 설정
  $translateProvider.useStaticFilesLoader({
    prefix: './lib/lang/',
    suffix: '.js'
  });
  $translateProvider.preferredLanguage('ko');

}

export default OnConfig;